<template>
  <a-card :bordered="false">
    <Breadcrumb routeName="PaySetting" toName="大额转账" goPathName="支付设置"></Breadcrumb>
    <a-form-model ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol" :model="ruleForm"
                  style="margin-top: 30px">
      <a-form-model-item label="支付状态" :required="true">
        <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.paymentStatus" :disabled="isAct"/>
      </a-form-model-item>
      <a-form-model-item label="最低可用金额" prop="largeTransferMinAmount" v-if="!isAct && ruleForm.paymentStatus">
        <a-input-number v-model="ruleForm.largeTransferMinAmount" style="width: 150px" :min="0.01" :max="1000000"
                        @change="changeMoney"/>
      </a-form-model-item>

      <a-form-model-item label=" " :colon="false" :required="false" v-if="isAct">
        您当前存在自有支付配置,暂不支持同时使用大额转账
        <a-form-model-item>
          <a-button @click="backEvent">返回</a-button>
        </a-form-model-item>
      </a-form-model-item>

      <a-form-model-item label=" " :colon="false" :required="false" v-else>
        <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
        <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import formMixin from '../../utils/mixins/formMixins'
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import countDownHelper from '../../utils/helper/countDownHelper'

export default {
  name: 'LargeAmountMoneyPaySetting',
  mixins: [formMixin],
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 12 },
      ruleForm: {
        paymentStatus: false,//支付状态
        largeTransferMinAmount: 500
      },
      rules: {
        largeTransferMinAmount: [
          { required: true, message: '请输入最低可用金额', trigger: 'blur' }
        ]
      },
      WxSetInfo: '',
      isAct: false //true不可操作
    }
  },
  mounted() {  //重置  this.$refs.ruleForm.resetFields();
    this.getPayState()
    this.getOwn()
  },
  activated() {

  },
  methods: {
    changeMoney(value) {
      this.ruleForm.largeTransferMinAmount = Number(value).toFixed(2)
      console.log(this.ruleForm.largeTransferMinAmount)
    },
    getOwn() {
      this.getHttpServices().getUserService().post('api/v2/paySetUp/query/own')
        .then(res => {
          this.isAct = res.own
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getPayState() {
      let params = {
        paymentMerchantId: this.$store.getters.userInfo.merchantId,
        paymentType: 7
      }
      this.getHttpServices().getUserService().post('/api/v2/paySetUp/query/details', params)
        .then(res => {
          this.WxSetInfo = res
          this.ruleForm.paymentStatus = res.paymentStatus == 1 ? true : false//支付状态
          this.ruleForm.largeTransferMinAmount = res.largeTransferMinAmount
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    saveEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData() {
      const params = {
        paymentId: this.WxSetInfo.paymentId,
        paymentMerchantId: this.WxSetInfo.paymentMerchantId,
        paymentStatus: this.ruleForm.paymentStatus ? 1 : 2,
        largeTransferMinAmount: this.ruleForm.largeTransferMinAmount
      }
      this.getHttpServices().getUserService().post('api/v2/paySetUp/paymentStatus/update', params)
        .then(res => {
          this.$message.success('设置成功')
          setTimeout(() => this.backEvent(), 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    }
  }

}
</script>
<style lang="less" scoped>
.single-import-box {
  margin-top: 30px;

  .upload-box {
    margin-top: 14px;
    height: 104px;
    position: relative;
  }

  .selected-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 104px;
  }

  .image-sample {
    position: absolute;
    top: 0;
    left: 200px;
    height: 104px;
  }

  .image-sample-1 {
    position: absolute;
    top: 0;
    left: 112px;
    height: 104px;
  }

  input {
    max-width: 400px;
  }

  .single-import-box > .ant-upload {
    width: 180px;
    height: 104px;
  }

  .picture-card .ant-upload-list-item {
    padding: 0;
  }
}

</style>